import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react';
import regulationAPI from './services/regulationAPI';
import databaseHealthAPI from './services/databaseHealthAPI';
import authReducer from './slice/authSlice';
import authapi from './services/authAPI';
import authSSOAPI from './services/authSSOAPI';
import userDetailsAPI from './services/userDetailsAPI';
import productsAPI from './services/productsAPI';
import regulationRequestAPI from './services/regulationRequestAPI';
import imageRequestAPI from './services/imageRequestAPI';
import syncDataAPI from './services/syncDataAPI';
import configurationAPI from './services/configurationAPI';
import dashboardAPI from './services/dashboardAPI';
import productImportAPI from './services/productImportAPI';
import linkupRequestAPI from './services/linkupRequestAPI';
import fileAPI from './services/fileAPI';
import logsAPI from './services/logsAPI';
import applicationsAPI from './services/applicationsAPI';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authapi.reducerPath]: authapi.reducer,
    [authSSOAPI.reducerPath]: authSSOAPI.reducer,
    [userDetailsAPI.reducerPath]: userDetailsAPI.reducer,
    [regulationAPI.reducerPath]: regulationAPI.reducer,
    [databaseHealthAPI.reducerPath]: databaseHealthAPI.reducer,
    [productsAPI.reducerPath]: productsAPI.reducer,
    [regulationRequestAPI.reducerPath]: regulationRequestAPI.reducer,
    [linkupRequestAPI.reducerPath]: linkupRequestAPI.reducer,
    [fileAPI.reducerPath]: fileAPI.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [productImportAPI.reducerPath]: productImportAPI.reducer,
    [logsAPI.reducerPath]:logsAPI.reducer,
    [syncDataAPI.reducerPath] : syncDataAPI.reducer,
    [configurationAPI.reducerPath]:configurationAPI.reducer,
    [imageRequestAPI.reducerPath]: imageRequestAPI.reducer,
    [applicationsAPI.reducerPath]: applicationsAPI.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    authapi.middleware,
    authSSOAPI.middleware,
    userDetailsAPI.middleware,
    regulationAPI.middleware,
    databaseHealthAPI.middleware,
    productsAPI.middleware,
    regulationRequestAPI.middleware,
    imageRequestAPI.middleware,
    syncDataAPI.middleware,
    configurationAPI.middleware,
    linkupRequestAPI.middleware,
    fileAPI.middleware,
    dashboardAPI.middleware,
    productImportAPI.middleware,
    logsAPI.middleware,
    applicationsAPI.middleware,
  ),

})
setupListeners(store.dispatch);